import React from 'react';
import './ReviewSearchBar.css';

const ReviewSearchBar = ({ searchQuery, onSearchChange, sortBy, onSortChange }) => {
  return (
    <div className="review-search-bar">
      <div className="search-input-wrapper">
        <span className="search-icon">🔍</span>
        <input
          type="text"
          className="search-input"
          placeholder="Search reviews..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
      <select
        className="sort-dropdown"
        value={sortBy}
        onChange={(e) => onSortChange(e.target.value)}
      >
        <option value="mostRecent">Sort by: Most Recent</option>
        <option value="highestRating">Sort by: Highest Rating</option>
        <option value="lowestRating">Sort by: Lowest Rating</option>
        <option value="mostHelpful">Sort by: Most Helpful</option>
      </select>
    </div>
  );
};

export default ReviewSearchBar;

